import axios from 'axios';
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { useParams } from 'react-router-dom';
import LecturesSingle from '../../Component/Lectures/LecturesSingle';
import Spinner from '../../Component/Spinner/Spinner';
export class LecturesPage extends Component {
    state = {
        dept_id:"",
        sem_id:"",
        course_id:"",
        loading:true,
        lecturesData:""
      }
      componentDidMount(){
        this.props.changeCoverTitle("Lectures Will Show Here")
        var sem_id = this.props.params.sem_id;
        var dept_id= this.props.params.dept_id;
        var course_id= this.props.params.course_id;
        this.setState({dept_id:dept_id,sem_id:sem_id,course_id:course_id})
    
        axios.get(`?getlectures&course_id=${course_id}`)
        .then((response)=>{
         this.setState({lecturesData:response.data, loading:false});
         console.log(response.data)
        })
       
      }
      render() {
        var lecturesDataRender = "";
        var lecturesData = this.state.lecturesData;
        lecturesDataRender = Object.keys(lecturesData)
        .map((i)=>{
        var lecture_name  = lecturesData[i].lecture_name ;
        var lecture_id  = lecturesData[i].lecture_id  ;
        var lecture_date = lecturesData[i].lecture_date ;
        var lecture_time = lecturesData[i].lecture_time ;
         var url ="/lecture/"+lecture_id;
        var time = lecture_date + ' '+lecture_time
        
    return <LecturesSingle url={url} lecture_name={lecture_name}  time={time}  />
        });    
    
        return (
          <>
            <div class="row">
 
    {this.state.loading?<Spinner/>:lecturesDataRender}
    </div>
          </>
        )
      }
    }

export default (props) => (
    <LecturesPage
        {...props}
        params={useParams()}
    />
  );